import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const ClientDemoPlanning = () => {
  return <CommingSoon />;
};

export default ClientDemoPlanning;
